<template>
  <div id="app">
    <el-container>
      <el-header :style="{display: kkk}">
        <div class="logo">
          <img src="./assets/img/hylogo.png" alt />
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
          text-color="black"
          active-text-color="#079b51"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-submenu index="/tiyou">
            <template slot="title">TiU Solution</template>
            <div style="display: flex;">
              <div style="width: 100%">
<!--                http://123.57.205.53:8090/-->
                <el-menu-item index="/tiyou">TiU Solution</el-menu-item>
                <el-menu-item @click="totiyou">教学提优云平台</el-menu-item>
              </div>
            </div>
          </el-submenu>
          <el-menu-item index="/ai">姿态捕捉</el-menu-item>
          <el-submenu index="3">
            <template slot="title">提供服务</template>
            <div style="display: flex;">
              <div style="width: 50%">
                <el-menu-item index="/szjc">数字化资源</el-menu-item>
                <el-menu-item index="/xqhz2">赛事服务</el-menu-item>
                <el-menu-item index="/xqhz1">校企深度育人</el-menu-item>
              </div>
              <div style="width: 50%">
                <el-menu-item index="/sxs">实训室建设</el-menu-item>
                <el-menu-item index="/xmsb">项目申报</el-menu-item>
              </div>
            </div>

          </el-submenu>
          <el-menu-item index="/about">关于我们</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <el-footer>
          <Footer></Footer>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Footer from "./views/Footer";

export default {
  data() {
    return {
      kkk: "flex",
      router: true,
      defaultActive: this.$route.path,
      isShow: true
    };
  },
  components:{
    Footer
  },

  created() {
  },
  mounted() {

  },
  watch:{
    '$route': 'getrouterPath',
    $router(to,from){
      console.log(to.path)
    }
  },
  methods: {
    handleSelect(key) {
      console.log(this.$route)
      this.defaultActive = "/" + this.$route.name;
    },
    getrouterPath(to,form){
      this.defaultActive = to.path
      if(this.$route.name === "home"){
        this.kkk = "none"
      }else{
        this.kkk = "flex"
      }
    },
    totiyou(){
      location.href="http://123.57.205.53:8090/"
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  //width: 1240px;
  width: 100%;
  margin: 0 auto;
  .logo {
    width: 280px;
    padding: 10px;
    display: flex;
    img {
      line-height: 60px;
      max-width: 100%;
      max-height: 100%;
    }
  }
}
.el-main {
  padding: 0 !important;
}
.el-footer{
  height: auto !important;
  width: 100%;
  background-color: #0b293d;
}
//.footer {
//  width: 100%;
//  height: 216px;
//  overflow: hidden;
//  background-color: #14679f;
//  &-content {
//    width: 1240px;
//    margin: 0 auto;
//    padding-top: 20px;
//    display: flex;
//    justify-content: space-between;
//    .content-nav {
//      display: flex;
//      justify-content: space-around;
//      li {
//        display: flex;
//        flex-direction: column;
//        padding: 0 20px;
//        //justify-content: center;
//        align-items: flex-start;
//        p {
//          font-size: 20px;
//          color: #d4edff;
//          padding: 10px 0;
//        }
//        span {
//          color: #f7f7f7;
//          font-weight: 300;
//          padding: 5px 0;
//        }
//      }
//    }
//    img {
//      width: 170px;
//      height: 170px;
//      padding: 10px;
//    }
//  }
//  .copyright {
//    height: 30px;
//    background: #125688;
//    span {
//      color: #fff;
//      line-height: 30px;
//    }
//  }
//}
</style>
